import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { BaseGoogleAnalyticsCategory } from '../../base-google-analytics-category';

enum ImageDialogAction {
  COMPARE = 'compare'
}

export class CompareDialog extends BaseGoogleAnalyticsCategory {
  constructor(ga: GoogleAnalyticsService, isEnabled: boolean) {
    super(ga, 'catalog_compare_dialog', isEnabled);
  }

  public compare(id1: string, id2: string) {
    this.event(ImageDialogAction.COMPARE, `${id1}_${id2}`);
  }
}
